<template>
  <span class="badge me-1 ps-0 enterprise"><font-awesome-icon icon="building"/> {{extractEnterprise()}}</span>
</template>

<script setup lang="ts">

interface Props {
  enterpriseId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  enterpriseId: ''
});

function extractEnterprise(): string {
  const enterpriseList = props.enterpriseId.split('.');
  return enterpriseList.length === 1 ? enterpriseList[0] : enterpriseList.slice(1).join(' > ');
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .enterprise {
    white-space: normal;
    text-align: left;
    color: black !important;
    background-color: transparent !important;
  }
</style>